const colors = [
  { header: "#2caeb4", body: "rgba(113, 213, 211, 0.87)" },
  { header: "#7979d2", body: "rgba(160, 160, 229, 0.87)" },
  { header: "#e76050", body: "rgba(231, 120, 114, 0.87)" },
  { header: "#f1b555", body: "rgba(252, 205, 121, 0.87)" },
  { header: "#5a93db", body: "rgba(127, 179, 244, 0.87)" },
  { header: "#ec8529", body: "rgba(247, 164, 109, 0.87)" },
  { header: "#4e342e", body: "rgba(188, 170, 164, 0.87)" },
  { header: "#DB8180", body: "rgba(233, 176, 175, 0.87)" },
  { header: "#698C7D", body: "rgba(174, 194, 185, 0.87)" },
  { header: "#A59F8D", body: "rgba(201, 197, 186, 0.87)" },
  { header: "#9c27b0", body: "rgba(169, 68, 178, 0.87)" },
  { header: "#e91e63", body: "rgba(244, 143, 177, 0.87)" },
  { header: "#673ab7", body: "rgba(144, 101, 181, 0.87)" },
  { header: "#3f51b5", body: "rgba(120, 144, 237, 0.87)" },
  { header: "#009688", body: "rgba(97, 207, 184, 0.87)" },
  { header: "#4caf50", body: "rgba(139, 226, 138, 0.87)" },
  { header: "#ff5722", body: "rgba(255, 151, 120, 0.87)" },
  { header: "#795548", body: "rgba(158, 133, 117, 0.87)" },
  { header: "#607d8b", body: "rgba(140, 158, 173, 0.87)" },
  { header: "#ff9800", body: "rgba(255, 183, 77, 0.87)" },
  { header: "#2196f3", body: "rgba(98, 176, 242, 0.87)" },
  { header: "#9e9e9e", body: "rgba(179, 179, 179, 0.87)" },
  { header: "#ffeb3b", body: "rgba(255, 237, 140, 0.87)" },
  { header: "#cddc39", body: "rgba(186, 212, 83, 0.87)" },
  { header: "#8bc34a", body: "rgba(148, 208, 91, 0.87)" },
  { header: "#ff5722", body: "rgba(255, 151, 120, 0.87)" },
  { header: "#f44336", body: "rgba(248, 91, 76, 0.87)" },
  { header: "#9c27b0", body: "rgba(169, 68, 178, 0.87)" },
  { header: "#3f51b5", body: "rgba(120, 144, 237, 0.87)" },
  { header: "#4caf50", body: "rgba(139, 226, 138, 0.87)" },
];

export default colors;